import Cookies from 'js-cookie';

export const removeAuthToken = (): void => {
  Cookies.remove('access_token', { domain: ENV.WHAT_ABILITY_DOMAIN, path: '/'});
  Cookies.remove('refresh_token', { domain: ENV.WHAT_ABILITY_DOMAIN, path: '/'});
};
